<template>
    <div id="bar-echart"></div>
  </template>
  
  <script>
  import axios from 'axios'
  import qs from 'qs'
  import echarts from "echarts";
  export default {
    props: {
      year: {
        type: Number,
        default: new Date().getFullYear()
      },
    },
    watch:{
      year(){
        this.$nextTick(() => {
        this.getList()
      })
      }
    },
    data() {
      return {
        chart: null,
        data:[],
        cmid:'',
        baseUrl:''
      }
    },
    mounted() {
      let user = JSON.parse(sessionStorage.getItem("userdata"));
      this.cmid = user.c_mid
      this.baseUrl = user.baseUrl
      this.$nextTick(() => {
        this.getList()
      })
      window.addEventListener("resize", this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);   
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      getList() {
        this.data = [0, 0, 0, 0, 0, 0, 0, 0,0, 0, 0, 0]
        axios({
            method: 'post',
            url: this.baseUrl + `/login/yueduanjianshuliang`,
            data:{
                cmid:this.cmid,
                nian:this.year
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.data = res.data.data
                this.$nextTick(() => {
                  this.initChart(res.data.data)
                })
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })

      },
      initChart(dataY) {
        this.chart = echarts.init(document.getElementById("bar-echart"));
        let dataX = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];

        let options = {
          color:['#3A96F5'],
          grid: {
            top: 35,
            left: '5%',
            right: '5%',
            bottom: '20',
            containLabel: true
          },
          tooltip: {
          trigger: "axis",
          axisPointer: {
              type: "shadow",
              label: {
                  show: true
              }
          }
      },
        xAxis: {
          data: dataX,
          axisLine: {
              lineStyle: {
                  color: '#D7DFEC'
              }
          },
          axisLabel:{
            interval:0,
            color:'#333'
          },
          axisTick:{
            show: false,
          }, 
      },
      yAxis: [{
        name:'单位：件',
              type: "value",
            //   splitNumber: 4,
          splitLine: {
              lineStyle: {
                  type: 'solid',
                  color: '#F2F2F2'
              }
          },
          axisLine: {
              show: false,
              lineStyle: {
                color: '#ADC2D8'
              },
          },
          nameTextStyle: {
              color: '#808080'
          },
          splitArea: {
              show: false
          },
          axisTick:{
            show: false,
          },
        }
      ],
      series: [
        {
            name: "案件数量/件",
            type: "bar",
            barWidth: 18,
            data: dataY
        }
      ]
        }
        this.chart.setOption(options
          )
      },
        resize(){
            if(this.chart){
                this.chart.resize();
            }
        }
    }
  }
  </script>

<style scoped>
#bar-echart{ width: 100%; height: 100%;}
</style>
  